module.exports = __webpack_public_path__ + "img/logo.fd6984bc.png";